"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mongoose = tslib_1.__importStar(require("mongoose"));
exports.schoolWithDistanceSchema = new mongoose.Schema({
    distance: {
        type: Number,
        index: true
    },
    school: { type: mongoose.Schema.Types.ObjectId, ref: 'School' }
});
//# sourceMappingURL=schoolWithDistance.js.map